import { Column, DefaultCellTypes, Row } from "@silevis/reactgrid";
import { renameField } from "../../General/Helpers";
import { CustomCellType } from "../CellTemplates/SortableHeaderCell";

export const columnWidth = (id: any) => {
  let width = 100;
  switch (id) {
    case " ":
      width = 40;
      return width;
    case "cr864_identifier":
      width = 180;
      return width;
    case "cr864_asisproject":
      width = 95;
      return width;
    case "cr864_phpc":
      width = 50;
      return width;
    case "cr864_codecompany":
    case "new_codecompany":
      width = 115;
      return width;
    case "cr864_unifiedcategory":
    case "new_unifiedcategory":
    case "new_zjednotenakategoria":
      width = 140;
      return width;
    case "cr864_category":
      width = 100;
      return width;
    case "cr864_collectioncategoryinbp":
    case "new_zbernakategoriavbp":
      width = 145;
      return width;
    case "_new_costcenter_value":
      width = 135;
      return width;
    default:
      return width;
  }
};

export const renameHeaderRow = (columns: Column[]): Row<CustomCellType> => {
  const rowHeight = 35;

  return {
    rowId: "header",
    height: rowHeight,
    cells: columns.map((c: Column) => ({
      type: "sortableHeader",
      text: renameField(c.columnId?.toString()),
      groupId: c.columnId,
      isFiltered: false,
    })),
  };
};

export const budgetPriorityColumns = [
  " ",
  "cr864_identifier",
  "cr864_asisproject",
  "cr864_phpc",
  "cr864_codecompany",
  "cr864_unifiedcategory",
  "_new_costcenter_value",
  "cr864_category",
  "cr864_collectioncategoryinbp",
];

export const historyBudgetPriorityColumns = [
  " ",
  "new_identifikator",
  "new_asisprojekt",
  "new_phpc",
  "new_codecompany",
  "new_zjednotenakategoria",
  "new_kategoria",
  "new_zbernakategoriavbp",
  "new_period",
];

export const ftePriorityColumns = ["new_codecompany", "new_unifiedcategory"];

export const historyFtePriorityColumns = [
  "new_codecompany",
  "new_zjednotenakategoria",
  "new_period",
];

export const originalFtePriorityColumns = [
  "new_codecompany",
  "new_zjednotenakategoria",
];

export const isNumberCell = (
  cell?: DefaultCellTypes
): cell is { type: "number"; value: number } =>
  cell != undefined && cell.type === "number" && typeof cell.value === "number";

export const isTextCell = (
  cell?: DefaultCellTypes
): cell is { type: "text"; text: string } =>
  cell != undefined && cell.type === "text" && typeof cell.text === "string";

export const isCheckboxCell = (
  cell?: DefaultCellTypes
): cell is { type: "checkbox"; checked: boolean } =>
  cell != undefined &&
  cell.type === "checkbox" &&
  typeof cell.checked === "boolean";

export const numberFilterOptions = [
  { value: "equals", label: "Equals" },
  { value: "morethan", label: "More than" },
  { value: "lessthan", label: "Less than" },
];
export const textFilterOptions = [
  { value: "equals", label: "Equals" },
  { value: "contains", label: "Contains" },
];

export const slovakMonthHeaders = [
  "Január",
  "Február",
  "Marec",
  "Apríl",
  "Máj",
  "Jún",
  "Júl",
  "August",
  "September",
  "Október",
  "November",
  "December",
];
export const sumFields = [
  "new_sum01",
  "new_sum02",
  "new_sum03",
  "new_sum04",
  "new_sum05",
  "new_sum06",
  "new_sum07",
  "new_sum08",
  "new_sum09",
  "new_sum10",
  "new_sum11",
  "new_sum12",
];
export const numericMonthHeaders = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

export const numericFields = [
  "new_01",
  "new_02",
  "new_03",
  "new_04",
  "new_05",
  "new_06",
  "new_07",
  "new_08",
  "new_09",
  "new_10",
  "new_11",
  "new_12",
];

export const DIGITS_WITH_UNDERSCORE = /^(\d+)_?(\d+)?$/;
export const DIGITS_ONLY = /^\d+$/;
export const DIGITS_PREFIX = /^(\d{3,4})_/;

export const isDigitsOnly = (value: string): boolean => DIGITS_ONLY.test(value);

export const getCellValue = (cell: DefaultCellTypes | undefined) => {
  if (isNumberCell(cell)) {
    return cell.value;
  } else if (isTextCell(cell)) {
    return cell.text;
  } else {
    return "";
  }
};

export const parseNumber = (value: any) => {
  if (
    value === "" ||
    value === null ||
    value === undefined ||
    Number.isNaN(value)
  ) {
    return null;
  }
  return Number(value);
};
